import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mine-us-phone",
  "use": "icon-mine-us-phone-usage",
  "viewBox": "0 0 11.83 17.643",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.83 17.643\" id=\"icon-mine-us-phone\"><defs><style>#icon-mine-us-phone .a{fill:none;stroke:#666;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><path class=\"a\" d=\"M1486.347,1178.783l9.425,7.417-9.425,7.417\" transform=\"translate(-1484.943 -1177.379)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol